import $ from 'jquery';

export default function(hp) {
  if ((hp.isIE8 || hp.isIE9 || hp.isIE10) && !hp.utils.getCookieByName('outdatedBrowserWarning')) {
    hp.utils.setCookie('outdatedBrowserWarning', 'shown');
    window.alert(
      'We’ve noticed you’re using an outdated web browser. That means things on our site won’t look right. And after January 1, 2018, things won’t display at all. What’s the fix? Get the current version of Internet Explorer or Chrome.'
    );
  }
}



// WEBPACK FOOTER //
// ./src/webpack/utils/browser-alert.js